// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4807":"3de02a527d582311","6320":"33c54bd7bbd63d61"}[chunkId] + ".css";
};